import { Button, Form, Select } from "antd";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { RouteChildrenProps, useLocation } from "react-router";
import { REPORTQUERYPARAMS, VALIDATION_MESSAGE_CONFIG } from "../../../../constants/constants";
import { LOCAL_STORAGE_KEY } from "../../../../constants/local";
import { ROUTE_PATHS } from "../../../../constants/url-config";
import HISTORY from "../../../../utils/history.helper";
import "./index.scss";
import { SettingIcon } from "../../../atoms/icon";

interface Props extends RouteChildrenProps { }

export const quarters = [{
    value: 1,
    text: "1st"
}, {
    value: 2,
    text: "2nd"
}, {
    value: 3,
    text: "3rd"
}, {
    value: 4,
    text: "4th"
}, {
    value: 5,
    text: "Year End"
}];

const FrontierSelectPeriod = (props: Props) => {

    const { state} = useLocation<{nextPathname: string}>();
    const planingCycleYears = () => {
        const now = new Date();
        const currentYear = now.getFullYear();
        const years = [];
        for (let index = currentYear - 5; index <= currentYear + 10; index++) {
            years.push(index);
        }
        return years;
    }

    const { t } = useTranslation();
    const years = useRef(planingCycleYears());

    const formSubmit = (values: any) => {
        localStorage.setItem(LOCAL_STORAGE_KEY.SCENARIO_FRONTIER_YEAR, values.fiscal_year);
        localStorage.setItem(LOCAL_STORAGE_KEY.SCENARIO_FRONTIER_QUARTER, values.quarter);

        if (state && state.nextPathname === ROUTE_PATHS.ScenarioFrontierNewReport) {
            HISTORY.push({
                pathname: ROUTE_PATHS.ScenarioFrontierNewReport,
                search: `${REPORTQUERYPARAMS.year}=${values.fiscal_year}&${REPORTQUERYPARAMS.quarter}=${values.quarter}`
            });
        } else {
            HISTORY.push(ROUTE_PATHS.ScenarioFrontierReports);
        }
    }

    useEffect(() => {
    }, [])

    return (
        <div className="frontier-select-period">
            <div className="step-content-item-wrapper">

                <div className="step-content-item-header">
                    <h4>
                        {t("RapmReport.lbSelectPeriod")}
                    </h4>
                </div>

                <Form
                    layout='vertical'
                    validateMessages={VALIDATION_MESSAGE_CONFIG}
                    onFinish={(values) => formSubmit(values)}
                    initialValues={{ fiscal_year: new Date().getFullYear() }}
                    scrollToFirstError>
                    <Form.Item
                        label={t("RapmReport.lbFiscalYear")}
                        name="fiscal_year"
                        rules={[{ required: true }]}>
                        <Select>
                            {years.current && years.current.map((item, index) => (
                                <Select.Option key={index} value={item}>
                                    {item}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={t("RapmReport.lbQuarter")}
                        rules={[{ required: true }]}
                        name="quarter">
                        <Select placeholder={t("Global.plPleaseSelect")}>
                            {quarters && quarters.map((item, index) => (
                                <Select.Option key={index} value={item.value}>
                                    {item.text}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item>
                        <Button htmlType="submit" type="primary" shape="round" block>
                            {
                                t("RapmReport.btnNext")
                            }
                        </Button>
                    </Form.Item>

                </Form>

            </div>

            <Button shape="round" type="default" className="setting-btn" onClick={() => props.history.push(ROUTE_PATHS.ScenarioFrontierConfiguration)} >
                <SettingIcon className="svg-icon" /> {t("ECAPLeader.btnConfiguration")}
            </Button>
        </div>

    )
}

export default FrontierSelectPeriod;